export default "__VITE_ASSET__CvbYWqCg__";